interface InputFieldProps
  extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  label?: string;
  onChange: (key: string, value: string | number) => void;
  options: { id: string; name: string }[];
  selected?: string;
  id?: string;
}

const Select = (props: InputFieldProps) => {
  const {
    className = '',
    options,
    id = '',
    onChange,
    label = '',
    selected = '',
    ...otherProps
  } = props;

  return (
    <div className={className}>
      {label && (
        <label className="text-gray-700 mb-0-5 block text-1-2" htmlFor={label}>
          {label} {otherProps.required && '*'}
        </label>
      )}
      <select
        className="w-full rounded-8-0 p-1-0 text-grey-800 text-body1 leading-1-25 border focus:outline-none"
        onChange={(e) => onChange(id, e.target.value)}
        {...otherProps}
      >
        {options?.map((option) => (
          <option
            key={option.id}
            value={option.id}
            selected={option.id === selected}
          >
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
